import { useTranslation } from "@/hooks/useTranslation";

export type SurveyOption = {
  value: string;
  text: string;
};

export const useSetupSurveyOptions = () => {
  const { t } = useTranslation();

  const getComeFromOptions = (): SurveyOption[] => [
    { value: "social-media", text: t("setup.survey.comeFrom.socialMedia") },
    { value: "google", text: t("setup.survey.comeFrom.google") },
    { value: "website", text: t("setup.survey.comeFrom.website") },
    { value: "word-of-mouth", text: t("setup.survey.comeFrom.wordOfMouth") },
    { value: "tv-radio", text: t("setup.survey.comeFrom.tvRadio") },
    { value: "press", text: t("setup.survey.comeFrom.press") },
    { value: "from-shaarper", text: t("setup.survey.comeFrom.fromShaarper") },
    { value: "existing-user", text: t("setup.survey.comeFrom.existingUser") },
    { value: "other", text: t("setup.survey.comeFrom.other") },
  ];

  const getWhatWaitingForOptions = (): SurveyOption[] => [
    { value: "save-time", text: t("setup.survey.whatWaitingFor.saveTime") },
    { value: "more-leads", text: t("setup.survey.whatWaitingFor.moreLeads") },
    { value: "ai-tasks", text: t("setup.survey.whatWaitingFor.aiTasks") },
    { value: "ease-of-use", text: t("setup.survey.whatWaitingFor.easeOfUse") },
    {
      value: "improve-relationship",
      text: t("setup.survey.whatWaitingFor.improveRelationship"),
    },
    {
      value: "understand-clients",
      text: t("setup.survey.whatWaitingFor.understandClients"),
    },
    {
      value: "competitive-intelligence",
      text: t("setup.survey.whatWaitingFor.competitiveIntelligence"),
    },
    { value: "other", text: t("setup.survey.whatWaitingFor.other") },
  ];

  return {
    comeFromOptions: getComeFromOptions(),
    whatWaitingForOptions: getWhatWaitingForOptions(),
  };
};
